/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createReducer } from 'typesafe-actions';
import { URL_REDIRECT, RedirectState, RedirectActionTypes, UNSET_URL_REDIRECT, UrlRedirectAction } from './types';
import { fetchLandingAndStylesRedirectsActions } from './actions';

const defaultState: RedirectState = {
    key: '',
    landingRedirectsIsFetching: false,
    landingRedirectsFetchingComplete: false,
};

const redirectReducer = createReducer<RedirectState, RedirectActionTypes>(defaultState)
    .handleAction(URL_REDIRECT, (state, action: UrlRedirectAction) => {
        return {
            ...state,
            data: action.payload,
            key: JSON.stringify(action.payload) || '',
        };
    })
    .handleAction(UNSET_URL_REDIRECT, (state, _) => {
        return {
            ...state,
            key: '',
            data: undefined,
        };
    })
    .handleAction(fetchLandingAndStylesRedirectsActions.request, (state, action) => {
        return {
            ...state,
            landingRedirectsIsFetching: true,
        };
    })
    .handleAction(fetchLandingAndStylesRedirectsActions.success, (state, action) => {
        return {
            ...state,
            landingRedirectsIsFetching: false,
            landingRedirectsFetchingComplete: true,
            landingRedirects: action.payload.data.data,
        };
    })
    .handleAction(fetchLandingAndStylesRedirectsActions.failure, (state, action) => {
        return {
            ...state,
            landingRedirects: undefined,
            landingRedirectsIsFetching: false,
            landingRedirectsFetchingComplete: false,
        };
    });

export default redirectReducer;
